export function ChevronRightIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M6.61,3.94a1,1,0,0,0,0,1.42l0,0L11.23,10,6.61,14.62a1,1,0,0,0,0,1.42l0,0a1,1,0,0,0,1.41,0l0,0,5.34-5.34a1,1,0,0,0,0-1.41l0,0L8.05,3.94a1,1,0,0,0-1.41,0Z" />
    </svg>
  )
}
